import React, { useEffect, useRef } from "react";
import { gsap, TweenMax, TimelineLite } from "gsap";
import * as ScrollMagic from "scrollmagic";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineLite);

import MainView from "features/new/main/view";

const Main = () => {
  const mainContentWrapper = useRef();

  const controller = new ScrollMagic.Controller();

  useEffect(() => {
    const ref = mainContentWrapper.current;

    if (ref) {
      const elements = ref.querySelectorAll(".main__animation--fade-in");

      elements.forEach((el) => {
        const action = gsap.fromTo(el, 0.2, { opacity: 0 }, { opacity: 1 });

        new ScrollMagic.Scene({
          triggerElement: el,
          duration: 500,
          triggerHook: 0.9,
        })
          .setTween(action)
          .addTo(controller);
      });
    }
  }, []);

  return <MainView innerRef={(el) => (mainContentWrapper.current = el)} />;
};

export default Main;
